import cashRegisters from './sections/CashRegisters/config'
import generalSettings from './sections/GeneralSettings/config'
import globalCashRegisters from './sections/GlobalCashRegisters/config'
import restaurantDesigner from './sections/RestaurantDesigner/config'
import automation from './sections/Automation/config'

export default [
	generalSettings,
	cashRegisters,
	restaurantDesigner,
	globalCashRegisters,
	automation
]
